<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Virtual Job Experience
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <li
    class="vs-sidebar--item"
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
  >
    <template v-if="isHelpPopupBtn">
      <button type="button" class="no-style w-full text-left" @click="showHelpPopup">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        <slot />
      </button>
    </template>
    <template v-else>
      <router-link
        v-if="to"
        v-show="shouldDisplay"
        exact
        :class="[{ 'router-link-active': activeLink }]"
        :to="to"
        :target="target"
      >
        <template v-if="iconType === 'svgSprite'">
          <svg-icon :name="icon" />
        </template>
        <template v-else>
          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        </template>
        <slot />
      </router-link>

      <a v-else :target="target" :href="href" tabindex="-1">
        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{ 'w-3 h-3': iconSmall }" :icon="icon" />
        <slot />
      </a>
    </template>
  </li>
</template>

<script>
import store from '@/store/store';
import SvgIcon from '../../../components/UI/SvgIcon';
export default {
  name: 'v-nav-menu-item',
  components: { SvgIcon },
  props: {
    icon: { type: String, default: '' },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: 'material-icons' },
    href: { type: [String, null], default: '#' },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    iconType: { type: String, default: 'featherIcon' },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: '_self' },
    isDisabled: { type: Boolean, default: false },
    isHelpPopupBtn: { type: Boolean, default: false },
  },
  computed: {
    activeLink() {
      return (
        !!((this.to === this.$route.path || this.$route.meta.parent === this.slug) && this.to) ||
        this.$route.path.includes(this.to)
      );
    },
    settings() {
      return store.getters['authStudent/settings'];
    },
    teacherAccessType() {
      return store.getters['authTeacher/accessType'];
    },
    shouldDisplay() {
      const login_type = localStorage.getItem('login_type');
      if (login_type === 'student')
        return (
          this.slug === null ||
          typeof this.settings[this.slug] == 'undefined' ||
          this.settings[this.slug] === true
        );
      else if (login_type === 'teacher') {
        //Show if menu item is not Students or is Students menu and access type is VJE only
        // TODO: add this back: return this.slug != 'teacher-students' || (this.slug == 'teacher-students' && this.teacherAccessType == 2);
        return this.slug != 'teacher-students';
      }
    },
  },
  methods: {
    showHelpPopup() {
      store.dispatch('popup/showHelpPopup');
    },
  },
};
</script>
